/* eslint-disable jsx-a11y/label-has-associated-control */

import { Colors } from "lcm-iot-commons";

type OwnProps = {
  id?: string;
  icon?: string;
  checked: boolean;
  onAddCheck: $TSFixMeFunction;
  onRemoveCheck: $TSFixMeFunction;
  listItem: {
    id: number;
    name?: string;
    value?: string;
    description?: string;
  };
};

const defaultProps: Partial<OwnProps> = {
  id: "list-item-with-checkbox",
  icon: "icon lcm-iot-icon-application",
};

type Props = OwnProps & typeof defaultProps;

// component can be moved to commons someday
function ListItemWithCheckBox({
  icon,
  checked,
  listItem,
  onAddCheck,
  onRemoveCheck,
}: Props) {
  const onCheckBoxClick = async () => {
    if (checked === true) {
      await onRemoveCheck(listItem.id);
    } else {
      await onAddCheck(listItem.id);
    }
  };

  return (
    <div className="list-item">
      <div className="clickable">
        <div className="list-item-icon primary">
          <i
            className={`icon ${icon}`}
            style={{ color: Colors.EH_WINTER_GRAY_2 }}
          />
        </div>
        <div className="list-item-content">
          <div className="list-item-content-wrapper">
            <div className="list-item-content-title">{listItem.name}</div>
            <div className="list-item-content-description">
              {listItem.description}
            </div>
          </div>
          {listItem.value ? (
            <div className="list-item-content-value">{listItem.value}</div>
          ) : null}
        </div>
      </div>

      <div className="list-item-checkbox">
        <input
          className="checkbox-input"
          id={`checkbox-input-item-${listItem.id}`}
          type="checkbox"
          checked={checked}
          onChange={onCheckBoxClick}
        />
        <label htmlFor={`checkbox-input-item-${listItem.id}`} />
      </div>
    </div>
  );
}

ListItemWithCheckBox.defaultProps = defaultProps;

export default ListItemWithCheckBox;
